import React from 'react';

import { PhoneIcon } from '@ergeon/icons/hero/micro';

export const AbandonedCallMessage: React.FC = () => (
  <div className="flex items-center gap-1">
    <PhoneIcon className="size-4" />
    <span>Call abandoned</span>
  </div>
);
